<script lang="ts" setup>
import { closeModal as pluginCloseModal } from '~/utils/Modal'

interface Props {
  nameModal: string
  disableTeleport?: boolean
  width?: number
  maxWidth?: number
}

const props = withDefaults(defineProps<Props>(), {
  nameModal: 'templateModal',
  disableTeleport: false,
  width: undefined,
  maxWidth: undefined,
})
const emit = defineEmits<{
  (e: 'close'): void
}>()

const slots = useSlots()

const modalWidth = computed(() => {
  return props.width === undefined ? '' : ('width: ' + props.width + 'px; ')
})

const modalMaxWidth = computed(() => {
  return props.maxWidth === undefined ? '' : ('max-width: ' + props.maxWidth + 'px; ')
})

const refModal: Ref = ref(null)

const closeModal = () => {
  pluginCloseModal()
  emit('close')
}

defineExpose({
  closeModal,
})

</script>

<template>
  <div
    class="modal fade show active prevent_unselection"
    tabindex="-1"
    ref="refModal"
    aria-hidden="true"
    data-backdrop="static"
    :style="'display: block; ' + modalWidth"
    :id="nameModal"
    :aria-labelledby="nameModal + 'Label'"
  >
    <div
      :style="modalMaxWidth"
      class="modal-dialog modal-dialog-centered"
    >
      <div
        class="modal-content"
        :style="modalWidth"
      >
        <div class="modal-header">
          <slot name="header" />
          <button
            type="button"
            class="btn-close"
            aria-label="Закрыть"
            @click="closeModal"
          />
          <button
            class="modal-btn-close"
            @click="closeModal"
          >
            <bootstrap-icon-x-lg />
          </button>
        </div>
        <div class="modal-body">
          <slot name="body" />
        </div>
        <div
          v-if="slots.footer"
          class="modal-footer"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
    <div
      v-if="slots.additional"
      class="modal-additional"
    >
      <slot name="additional" />
    </div>
  </div>
</template>

<style lang="scss">

.modal {
  width: unset;
  height: unset;
  position: unset;
  max-height: calc(100dvh - 24px);
  overflow-x: hidden;
  overflow-y: auto;

  @include media-breakpoint-down(lg) {
    width: 100%;

    .modal-dialog {
      max-width: 100%;
    }
  }
}

.modal-dialog {
  margin: unset;
}

.modal-content {
  @include media-breakpoint-down(lg) {
    border: none;
    border-radius: rem(4px) rem(4px) 0 0;
    padding-bottom: rem(40px);
  }

  @include media-breakpoint-down(md) {
    padding-bottom: rem(24px);
  }
}

.modal-header {
  gap: 0 rem(8px);
  align-items: flex-start;

  @include media-breakpoint-down(lg) {
    padding: rem(12px) rem(12px) rem(8px);
    border: none;
  }

  .btn-close {
    @include media-breakpoint-down(lg) {
      display: none;
    }
  }

  .modal-btn-close {
    border: none;
    margin: 0;
    padding: 0;
    flex-shrink: 0;
    color: $gray-900;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $gray-100;
    width: rem(24px);
    height: rem(24px);
    border-radius: rem(3px);

    @include media-breakpoint-up(lg) {
      display: none;
    }

    svg {
      width: rem(12px);
      height: rem(12px);
    }
  }
}

.modal-body {
  min-width: 466px;

  @include media-breakpoint-down(lg) {
    min-width: 100%;
    padding: 0 rem(12px);
  }
}

.modal-footer {
  @include media-breakpoint-down(lg) {
    border: none;
    padding: rem(20px) rem(12px) 0;
    margin: rem(-4px);
    justify-content: flex-start;
  }

  @include media-breakpoint-down(md) {
    flex-direction: column-reverse;

    .btn {
      width: calc(100% - 8px);
    }
  }
}
</style>
